import { utcToLocal } from '../../utils/dateHelper'
import { TableHeaderConfig } from '../_EOS/Table'

export const workOrderBlogTableHeaderConfig: TableHeaderConfig[] = [
  {
    field: 'createdDate',
    title: 'Fecha',
    sortable: true,
    formater: (value) => utcToLocal(value, 'dd/MM/yyyy HH:mm:ss')
  },
  {
    field: 'workOrderState',
    title: 'Estado',
    formater: (value) => value.charAt(0).toUpperCase() + value.slice(1)
  },
  { field: 'comments', title: 'Comentarios' },
  { field: 'createdUser', title: 'Usuario' }
]
